<template>
<w-tool-tabs class="tab-button" size="mini" v-model="activeTab">
  <el-row slot="tool" type="flex" justify="end">
    <w-config-edit-tool class="mr-r4" v-show="visibleEditButton"></w-config-edit-tool>
    <!-- 그룹 저장 -->
    <div>
      <el-button v-show="!isConfigEditing && visibleEditButton" type="secondary" size="small" @click="openGroupSavePopup">그룹 저장</el-button>
      <w-group-save-popup ref="groupSavePopup" :selected-obj="selectedNode" :config-data="configData" />
    </div>
  </el-row>
  <el-tab-pane label="구성 현황" name="WConfigStatus" >
      <w-config-status :nodeParams="nodeParams" @setConfigData="setConfigData" />
  </el-tab-pane>
</w-tool-tabs>
</template>

<script>
import { mapGetters } from 'vuex';
import isNil from 'lodash/isNil';

import ConfigNodeTab from '@/mixins/config/config-node-tab';
import WConfigStatus from './configstatus';

export default {
  name: 'WConfigServiceeNode',
  mixins: [ConfigNodeTab],
  components: {
    WConfigStatus,
  },
  computed: mapGetters(['selectedNode']),
  data() {
    return {
      activeTab: 'WConfigStatus',
      nodeParams: {},
      params: {
        objId: null,
      },
      configData: {},
    };
  },
  watch: {
    selectedNode: {
      handler() {
        if (!this.active) {
          return;
        }
        if (!isNil(this.selectedNode)) {
          this.params.objId = this.selectedNode.obj.objId;
          this.loadParams();
        }
      },
      immediate: true,
    },
    active(active) {
      if (active) {
        this.params.objId = this.selectedNode.obj.objId;
        this.loadParams();
      }
    },
  },
  methods: {
    loadParams() {
      const me = this;
      if (!isNil(this.params.objId)) {
        me.nodeParams = Object.assign({}, this.params);
      }
    },
    /**
     * 그룹 저장시 데이터 비교할 구성정보 데이터를 바인딩한다.
     * @param  {[type]} configData [description]
     * @author jda
     */
    setConfigData(configData) {
      this.configData = configData;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/service/index.vue